/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.hero-banner .location-box select' ).change( function( e ) {
        $( '.hero-banner .location-box address' ).not( '[data-id="' + $( this ).find( 'option:selected' ).attr( 'data-id' ) + '"]' ).removeClass( 'is-active' );
        $( '.hero-banner .location-box address[data-id="' + $( this ).find( 'option:selected' ).attr( 'data-id' ) + '"]' ).addClass( 'is-active' );
      } );

      $( '.hero-banner .scroll-down' ).click( function() {
        const target = $( this ).closest( '.hero-banner' ).next();
        let wpadminBarHeight = 0;
        if ( $( '#wpadminbar' ).length > 0 ) {
          wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
        }
        const headerHeight = $( 'header.navbar' ).outerHeight();
        if ( target.length ) {
          $( 'html, body' ).animate( {
            scrollTop: target.offset().top - ( headerHeight + wpadminBarHeight ),
          }, 1000 );
          $( target ).focus();
          return false;
        }
      } );

      $( '.hero-banner form' ).submit( function( e ) {
        localStorage.setItem( 'kcoaCurrentLocation', $( this ).find( 'select option:selected' ).attr( 'data-id' ) );
        localStorage.setItem( 'kcoaCurrentLocationName', $( this ).find( 'select option:selected' ).attr( 'data-name' ) );
      } );

      if ( localStorage.getItem( 'kcoaCurrentLocation' ) ) {
        $( '.hero-banner select option[data-id="' + localStorage.getItem( 'kcoaCurrentLocation' ) + '"]' ).attr( 'selected', '' );

        $( '.hero-banner .location-box address' ).not( '[data-id="' + localStorage.getItem( 'kcoaCurrentLocation' ) + '"]' ).removeClass( 'is-active' );
        $( '.hero-banner .location-box address[data-id="' + localStorage.getItem( 'kcoaCurrentLocation' ) + '"]' ).addClass( 'is-active' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
